module.exports = __webpack_public_path__ + "img/gonganbu.d0289dc0.png";